import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import PageLoader from '../pages/Landing/LoadingPage';

interface SuperuserRouteProps {
  children: React.ReactNode;
}

const SuperuserRoute: React.FC<SuperuserRouteProps> = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <PageLoader />;
  }

  // Prevent false 404s while user profile is hydrating with a valid token
  if (isAuthenticated() && !user) {
    return <PageLoader />;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but not a superuser, show 404
  if (!user?.is_superuser) {
    return <Navigate to="/404" replace />;
  }

  // If authenticated and is a superuser, render the children
  return <>{children}</>;
};

export default SuperuserRoute;
